<template>
  <div class="card">
    <div class="table-resposnive general-noti">
      <table class="table">
        <thead>
          <tr>
            <th>General Notification</th>
            <th>Push</th>
            <th>SMS</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="record in Notification_Settings" :key="record.id">
            <td>
              <div class="table-content">
                <h6>{{ record.GeneralNotification }}</h6>
              </div>
            </td>
            <td>
              <div class="active-switch">
                <label class="switch">
                  <input type="checkbox" :checked="record.Checked" />
                  <span class="sliders round"></span>
                </label>
              </div>
            </td>
            <td>
              <div class="active-switch">
                <label class="switch">
                  <input type="checkbox" :checked="record.Checked1" />
                  <span class="sliders round"></span>
                </label>
              </div>
            </td>
            <td>
              <div class="active-switch">
                <label class="switch">
                  <input type="checkbox" :checked="record.Checked2" />
                  <span class="sliders round"></span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Notification_Settings from "@/assets/json/admin/notification-settings.json";
export default {
  data() {
    return {
      Notification_Settings: Notification_Settings,
    };
  },
};
</script>
